import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Sparkles, Calendar, Video, Star } from 'lucide-react';
export function OfferStack() {
  // IDs de Variantes de Shopify
  const ID_TOOLKIT = '43864513380440';
  const ID_REELS = '43864611520600';
  const ID_CALENDAR = '43864790302808';

  // Enlaces de Checkout Directos (Permalinks)
  const links = {
    toolkit: `https://checkout.digitalsolvex.shop/cart/${ID_TOOLKIT}:1`,
    toolkitReels: `https://checkout.digitalsolvex.shop/cart/${ID_TOOLKIT}:1,${ID_REELS}:1`,
    toolkitCalendar: `https://checkout.digitalsolvex.shop/cart/${ID_TOOLKIT}:1,${ID_CALENDAR}:1`,
    vipAll: `https://checkout.digitalsolvex.shop/cart/${ID_TOOLKIT}:1,${ID_REELS}:1,${ID_CALENDAR}:1`
  };
  return <section id="comprar" className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden w-full relative z-20" data-id="element-149">
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 to-green-500/10 rounded-[40px] blur-[100px]" data-id="element-150" />

      <div className="relative bg-[#050505] border border-white/10 shadow-2xl rounded-[40px] p-6 md:p-14 overflow-hidden" data-id="element-151">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-152" />

        <div className="text-center mb-12" data-id="element-153">
          <h2 className="font-heading text-3xl md:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-154">
            Elige tu <span className="text-cyan-400" data-id="element-155">Nivel de Crecimiento</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-156">
            Selecciona el paquete que mejor se adapte a las necesidades de tu negocio. Pago único, acceso de por vida.
          </p>
        </div>

        {/* GRID HORIZONTAL DE 4 OPCIONES */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-157">
          
          {/* OPCIÓN 1: BÁSICO */}
          <div className="flex flex-col bg-white/[0.02] border border-white/5 hover:border-white/20 rounded-3xl p-6 transition-all duration-300" data-id="element-158">
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-159">Básico</h3>
            <p className="text-gray-400 text-sm mb-4 min-h-[40px]" data-id="element-160">Lo esencial para organizar tus precios.</p>
            <div className="mb-6" data-id="element-161">
              <span className="text-4xl font-black text-white" data-id="element-162">$17.00</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1 text-sm text-gray-300" data-id="element-163">
              <li className="flex items-start gap-2" data-id="element-164">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-165" /> 
                <span data-id="element-166">Toolkit Digital Pro</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-167">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-168" /> 
                <span data-id="element-169">Calculadora de Precios</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-170">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-171" /> 
                <span data-id="element-172">100 Plantillas Canva</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-173">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-174" /> 
                <span data-id="element-175">Scripts de Cierre de Ventas para WhatsApp</span>
              </li>
            </ul>
            <a href={links.toolkit} className="w-full py-3 px-4 bg-white/10 hover:bg-white/20 text-white font-bold rounded-xl text-center transition-all" data-id="element-176">
              Comprar Básico
            </a>
          </div>

          {/* OPCIÓN 2: TOOLKIT + REELS */}
          <div className="flex flex-col bg-white/[0.02] border border-white/5 hover:border-white/20 rounded-3xl p-6 transition-all duration-300" data-id="element-177">
            <div className="flex items-center gap-2 text-green-400 font-bold text-xs mb-2 uppercase tracking-widest" data-id="element-178">
              <Video className="w-4 h-4" data-id="element-179" /> Más Visibilidad
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-180">Viral</h3>
            <p className="text-gray-400 text-sm mb-4 min-h-[40px]" data-id="element-181">Toolkit + Guiones para videos cortos.</p>
            <div className="mb-6 flex items-end gap-2" data-id="element-182">
              <span className="text-4xl font-black text-white" data-id="element-183">$26.99</span>
              <span className="text-sm text-gray-500 line-through mb-1" data-id="element-184">$36.99</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1 text-sm text-gray-300" data-id="element-185">
              <li className="flex items-start gap-2" data-id="element-186">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-187" /> 
                <span className="font-bold text-white" data-id="element-188">Todo lo del Básico</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-189">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-190" /> 
                <div data-id="element-191">
                  <span className="block font-bold text-white" data-id="element-192">Kit 50 Reels Virales</span>
                  <span className="block text-xs text-gray-400 mt-1 leading-tight" data-id="element-193">Estructuras probadas (Gancho, Cuerpo y Cierre) para retener la atención.</span>
                </div>
              </li>
              <li className="flex items-start gap-2" data-id="element-194">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-195" /> 
                <div data-id="element-196">
                  <span className="block font-bold text-white" data-id="element-197">Cero Bloqueos</span>
                  <span className="block text-xs text-gray-400 mt-1 leading-tight" data-id="element-198">Ideas listas para grabar sin pensar qué decir.</span>
                </div>
              </li>
            </ul>
            <a href={links.toolkitReels} className="w-full py-3 px-4 bg-green-500/20 hover:bg-green-500/30 text-green-400 font-bold rounded-xl text-center transition-all" data-id="element-199">
              Llevar Paquete Viral
            </a>
          </div>

          {/* OPCIÓN 3: TOOLKIT + CALENDARIO */}
          <div className="flex flex-col bg-white/[0.02] border border-white/5 hover:border-white/20 rounded-3xl p-6 transition-all duration-300" data-id="element-200">
            <div className="flex items-center gap-2 text-cyan-400 font-bold text-xs mb-2 uppercase tracking-widest" data-id="element-201">
              <Calendar className="w-4 h-4" data-id="element-202" /> Más Organización
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-203">Estratega</h3>
            <p className="text-gray-400 text-sm mb-4 min-h-[40px]" data-id="element-204">Toolkit + Un año de ideas de contenido.</p>
            <div className="mb-6 flex items-end gap-2" data-id="element-205">
              <span className="text-4xl font-black text-white" data-id="element-206">$31.99</span>
              <span className="text-sm text-gray-500 line-through mb-1" data-id="element-207">$44.00</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1 text-sm text-gray-300" data-id="element-208">
              <li className="flex items-start gap-2" data-id="element-209">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-210" /> 
                <span className="font-bold text-white" data-id="element-211">Todo lo del Básico</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-212">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-213" /> 
                <div data-id="element-214">
                  <span className="block font-bold text-white" data-id="element-215">Calendario 365 Días</span>
                  <span className="block text-xs text-gray-400 mt-1 leading-tight" data-id="element-216">El mapa exacto de qué publicar cada día del año (Reels, Carruseles, etc).</span>
                </div>
              </li>
              <li className="flex items-start gap-2" data-id="element-217">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-218" /> 
                <div data-id="element-219">
                  <span className="block font-bold text-white" data-id="element-220">Ahorra Tiempo</span>
                  <span className="block text-xs text-gray-400 mt-1 leading-tight" data-id="element-221">Despierta sabiendo exactamente qué subir hoy a tus redes.</span>
                </div>
              </li>
            </ul>
            <a href={links.toolkitCalendar} className="w-full py-3 px-4 bg-cyan-500/20 hover:bg-cyan-500/30 text-cyan-400 font-bold rounded-xl text-center transition-all" data-id="element-222">
              Llevar Paquete Estratega
            </a>
          </div>

          {/* OPCIÓN 4: VIP (TODO INCLUIDO) - RECOMENDADO */}
          <motion.div whileHover={{
          y: -5
        }} className="flex flex-col bg-gradient-to-b from-green-500/10 to-cyan-500/10 border-2 border-cyan-400 rounded-3xl p-6 relative shadow-[0_0_30px_rgba(34,197,94,0.15)]" data-id="element-223">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-green-400 to-cyan-400 text-black font-black text-xs uppercase tracking-widest py-1 px-4 rounded-full flex items-center gap-1 shadow-lg" data-id="element-224">
              <Star className="w-3 h-3" data-id="element-225" /> Recomendado
            </div>
            <h3 className="text-xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400 mb-2 mt-2" data-id="element-226">Paquete VIP Total</h3>
            <p className="text-gray-300 text-sm mb-4 min-h-[40px]" data-id="element-227">El ecosistema definitivo para tu negocio.</p>
            <div className="mb-6 flex items-end gap-2" data-id="element-228">
              <span className="text-4xl font-black text-white" data-id="element-229">$41.98</span>
              <span className="text-sm text-gray-500 line-through mb-1" data-id="element-230">$63.99</span>
            </div>
            <ul className="space-y-4 mb-8 flex-1 text-sm text-white font-medium" data-id="element-231">
              <li className="flex items-start gap-2" data-id="element-232">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-233" /> 
                <span data-id="element-234">Toolkit Digital Pro Completo</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-235">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-236" /> 
                <div data-id="element-237">
                  <span className="block" data-id="element-238">Kit 50 Reels Virales</span>
                  <span className="block text-[11px] text-gray-300 mt-0.5 font-normal leading-tight" data-id="element-239">Guiones listos para atraer clientes.</span>
                </div>
              </li>
              <li className="flex items-start gap-2" data-id="element-240">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-241" /> 
                <div data-id="element-242">
                  <span className="block" data-id="element-243">Calendario 365 Días</span>
                  <span className="block text-[11px] text-gray-300 mt-0.5 font-normal leading-tight" data-id="element-244">Planificación de un año entero.</span>
                </div>
              </li>
              <li className="flex items-start gap-2 mt-4 text-cyan-300 text-xs italic" data-id="element-245">
                Ahorras más de $22.00 dólares con este paquete.
              </li>
            </ul>
            <a href={links.vipAll} className="w-full py-3 px-4 bg-gradient-to-r from-green-500 to-cyan-500 hover:from-green-400 hover:to-cyan-400 text-white font-black uppercase tracking-wide rounded-xl text-center transition-all shadow-lg flex items-center justify-center gap-2" data-id="element-246">
              ¡Quiero Todo!
            </a>
          </motion.div>

        </div>

        {/* PIE DE GARANTÍA */}
        <div className="mt-12 flex flex-wrap justify-center gap-8 text-gray-500 text-xs font-bold uppercase tracking-widest border-t border-white/10 pt-8" data-id="element-247">
          <span className="flex items-center gap-2" data-id="element-248">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-249" /> Pago Seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-250">Pago Móvil / Binance / PayPal</span>
          <span className="flex items-center gap-2" data-id="element-251">Entrega Inmediata</span>
        </div>
      </div>
    </section>;
}